export class AdRate {
  id: BigInteger;
  pageone: DoubleRange;
  pagelast: DoubleRange;
  pagebetween: DoubleRange;
  fullpage: DoubleRange;
  halfpage: DoubleRange;
  quarterpage: DoubleRange;
  adcolor: Int16Array;
}
